export const sameOrder = (a, b) => a.length === b.length && a.every((id, i) => id === b[i]);
export const mediaType = (row) => Number(row.asset.asset_type_id ?? row.asset.asset_type.key);

export function placeIn(order, visible, arranged, id) {
  const from = visible.indexOf(id), to = arranged.indexOf(id);
  if (from < 0 || to < 0 || from === to || !order.includes(id)) return order;
  const result = order.filter(value => value !== id);
  const neighbor = to < from ? arranged[to + 1] : arranged[to - 1];
  const at = result.indexOf(neighbor);
  if (at < 0) return order;
  result.splice(at + (to < from ? 0 : 1), 0, id);
  return result;
}

export function moveTo(order, id, position) {
  if (!Number.isInteger(position) || position < 1 || position > order.length || !order.includes(id)) throw new Error(`Escribe un número entre 1 y ${order.length}.`);
  const next = order.filter(value => value !== id);
  next.splice(position - 1, 0, id);
  return next;
}

export const buildPayload = (propertyId, type, order) => ({
  property_id: propertyId,
  asset_type_id: type,
  asset_files: order.map((id, i) => ({ id, main: type === 1 && i === 0 ? 1 : 0 })),
});

export function reconcileDrafts(previous, resources) {
  const next = {};
  for (let type = 1; type <= 4; type++) {
    const server = resources.filter(row => Boolean(Number(row.published)) && mediaType(row) === type).map(row => row.asset_id);
    const old = previous[type];
    if (old && !sameOrder(old.saved, old.working)) {
      const membershipChanged = old.saved.length !== server.length || old.saved.some(id => !server.includes(id));
      next[type] = { ...old, stale: old.stale || membershipChanged };
    } else {
      next[type] = { saved: server, working: server, stale: false };
    }
  }
  return next;
}
